// extracted by mini-css-extract-plugin
export default {"container2":"PaymentSuccess_container2__cgpDp","banner":"PaymentSuccess_banner__i+VfP","icon":"PaymentSuccess_icon__b8fe9","pattern":"PaymentSuccess_pattern__yJWDh"};